const ReferralsTab: React.FC = () => {
  return (
    <>
      <img src='http://via.placeholder.com/640x360'></img>
    </>
  );
}

export default ReferralsTab;
